export default "Isolation toiture-terrasse BAT-EN-101 — Tertiaire | Solution Éco France";
